import { supabase } from '@/common/config/supabase';

export const withAuthUser = async <T>(operation: (userId: string) => Promise<T>): Promise<T> => {
  const {
    data: { user },
    error: authError,
  } = await supabase.auth.getUser();

  if (authError || !user) {
    throw new Error('User not authenticated');
  }

  return operation(user.id);
};
